import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SessionRequest } from '../api/models/SessionRequest';
import { SessionResponse } from '../api/models/SessionResponse';
import { SessionKeys } from '../constants/upplm.constants';
import { LocationDetailsSession } from '../api/models/locationDetailsSession';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })

};
const headers = new HttpHeaders().set("Content-Type", "application/json");

@Injectable()
export class UpplmSessionService {
    public key: string;
    public sessionData: SessionResponse = new SessionResponse();

    constructor(@Inject(HttpClient) private httpclient: HttpClient) {

    }

    createSession(apiurl): Observable<any> {
        let request = new SessionRequest();
        request.key = '';
        let _body = JSON.stringify(request);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }

    createSessionWithParameters(apiurl: string, nickName: string, clientKey: string): Observable<any> {
        let request = new SessionRequest();
        request.key = '';
        request.locationDetails = new LocationDetailsSession();
        request.locationDetails.nickname = nickName;
        request.locationDetails.clientKey = clientKey;
        request.locationDetails.comesFromURL = (nickName !== '' || clientKey !== '') ? true : false;
        let _body = JSON.stringify(request);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }

    mapSessionResponse(response: SessionResponse) {
        if (response !== null) {
            this.key = response.key;
            this.sessionData = response;
        }
    }

    getSessionData(apiurl, key: string): Observable<any> {
        let request = new SessionRequest();
        request.key = key;
        let _body = JSON.stringify(request);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }

    setSessionData(apiurl, request: SessionRequest): Observable<any> {
        let _body = JSON.stringify(request);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }

    cleanSessionData(apiurl): Observable<any> {
        let request: SessionRequest = new SessionRequest();
        request.key = this.sessionData.key;
        request.locationDetails = new LocationDetailsSession();
        request.locationDetails.clientKey = "";
        request.locationDetails.nickname = "";
        request.temporaryLocation = null;
        request.contactDetails = null;
        request.placardDetails = null;
        request.pickupDetails = null;
        request.notificationDetails = null;
        request.createPickUp = null;
        this.sessionData.locationDetails = null;
        this.sessionData.temporaryLocation = null;
        this.sessionData.contactDetails = null;
        this.sessionData.placardDetails = null;
        this.sessionData.pickupDetails = null;
        this.sessionData.notificationDetails = null;
        this.sessionData.createPickUp = null;
        let _body = JSON.stringify(request);
        let url = apiurl;
        return this.httpclient.post<any>(url, _body, httpOptions);
    }

    isValidSession(): boolean {
        let isValid = false;
        let lastTimeSessionReqired: Date = new Date(this.sessionData.lastTimeSessionReqired);
        lastTimeSessionReqired.setTime(lastTimeSessionReqired.getTime() + (SessionKeys.TIMEOUT * 60 * 1000));
        if (lastTimeSessionReqired < new Date()) {
            isValid = false;
        }
        else {
            isValid = true;
        }
        return isValid;
    }
}